import { Link } from "react-router-dom";
// type
import { TMainPageLayoutV3 } from "../type";
// types
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";


const MNPG060 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG060.rendered: ", props);

    const phone = metaDataLanguageVersion("phone", props.template?.languageVersions);
    const email = metaDataLanguageVersion("email", props.template?.languageVersions);
    const address = metaDataLanguageVersion("address", props.template?.languageVersions);
    const mapURL = metaDataLanguageVersion("mapURL", props.template?.languageVersions);

    return (
        <ul className="contact-list">
            <li>
                <i className="fal fa-map-marker-alt"></i>
                <Link to={mapURL} aria-label="address">{address}</Link>
            </li>
            <li>
                <i className="fal fa-envelope"></i>
                <Link to={`mailto:${email}`} className="link" aria-label="email">
                    {email}
                </Link>
            </li>
            <li>
                <i className="far fa-phone"></i>
                <Link to={`tel:${phone?.trim()?.replace(/[^0-9]/g, "")}`} aria-label="phone">
                    {phone}
                </Link>
            </li>
        </ul>
    )
}

export default MNPG060;
